export default __webpack_public_path__ + "static/trending_collections-913ba952969e25e4f7926623a99e04f6.png";